import { registerBlockVariation } from "@wordpress/blocks";
import { __ } from "@wordpress/i18n";

export function queryCarouselVariation() {
    registerBlockVariation('core/query', {
        name: 'aptum-query-loop-carousel',
        title: __('Aptum Query Loop Carousel', 'site'),
        description: 'Displays posts in a carousel on mobile.',
        keywords: ['grid', 'posts', 'Aptum'],
        scope: ['inserter', 'block'],
		    icon: 'slides',
        attributes: {
            query: {
                perPage: 10,
                pages: 0,
                offset: 0,
                postType: 'post',
                order: 'desc',
                orderBy: 'date',
                author: '',
                search: '',
                exclude: [],
                sticky: '',
                inherit: false,
                taxQuery: null,
                parents: [],
                format: []
            },
			      metadata: {
                name: __('Aptum Query Loop Carousel', 'site')
            },
            align: 'wide',
						className:'is-style-carousel'
        },
        innerBlocks: [
            [
                'core/post-template',
                {
                    layout: {
                        type: 'grid',
                        columnCount: 3
                    }
                },
                [
                    ['core/post-title'],
                    ['core/post-date']
                ]
            ],
        ]
    });
}
